import { C, P0, R, S, abs, arc, fillAt } from '../../geometry';

export const magnifier = {
  name: 'Magnifier',
  colors: ['#1FA2D6', '#161616'],
  draw(m, t) {
    let r = 23,
      tx = 1.5 * S(t * 0.9),
      ty = 1.5 * S(t * 1.3),
      pose = P0();
    if (m === 'happy') {
      ty = -3 * abs(S(t * 6));
      pose.rot = 8 * S(t * 6);
    }
    // Thinking: keeps scanning around in a slow circle, searching.
    if (m === 'thinking') {
      tx = 7 * C(t * 2);
      ty = 5 * S(t * 2);
    }
    if (m === 'talking') r = 23 + 1.5 * S(t * 10);
    if (m === 'surprised') {
      r = 27;
    }
    if (m === 'paused') {
      pose.rot = 24 + S(t * 0.7);
      ty = 4;
    }
    const cx = 43 + tx,
      cy = 43 + ty,
      a = 45 * R;
    const handle = [
      [cx + (r + 2) * C(a), cy + (r + 2) * S(a)],
      [cx + (r + 19) * C(a), cy + (r + 19) * S(a)],
    ];
    const glint = arc(cx, cy, r - 7, 200, 245, 4);
    return {
      strokes: [
        { c: 'a', pts: arc(cx, cy, r, 0, 359, 18), n: 26 },
        { c: 'b', pts: handle },
        { c: 'a', pts: glint, o: 0.5, detail: true },
      ],
      eyes: { x: cx, y: cy + 1 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    fillAt(f, 0);
    f.strokes[2] = { ...f.strokes[2], o: 0 };
    return f;
  },
};
